import { Box, Button, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { amber, bgRed, green, headingBlue, lightGrey, maroon, mediumGrey, orange } from '../../../assets/colors'
import { tableOffsets2, taskTypeList } from '../../../utils/constants'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import CustomDropDown from '../../CustomDropDown'

const TaskTable = (props) => {
	var outerBoxStyle= {
    width: '100%',
    height: '52vh',
    marginTop: "0.6rem"
  }

	var paperStyle={
    // width: "100%",
    // height: '100%',
    border: '1px solid #D9D9D9',
    padding: "0.2rem 0.1rem 0.1rem 0.1rem",
  }

	var headerBoxStyle = {
    display: 'flex',
		justifyContent: 'center',
    padding: "0.3rem",
    flexWrap: 'wrap',
  }

	var internalBoxStyle= {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '20%',
    flex: '1 1',
    flexDirection: "row",
    flexWrap: 'wrap'
    // padding: "0.1rem 2rem"
  }

	var typographyStyle= {
    marginLeft: "0.5rem",
    padding:"0.1rem",
    fontSize: "1rem",
    fontWeight: "600"
  }

	var headerCellStyle = {
    padding: '0.2rem 0.5rem 0.2rem 0.5rem', 
    fontSize: "0.9rem",
    fontWeight: "400",
    textAlign: 'center'
  }

  return (
    <>
    <Box style={outerBoxStyle}>
			<Paper style={paperStyle}>
				<Box style={headerBoxStyle}>
					<Box style={internalBoxStyle}>
						<Typography style={typographyStyle}>  Task Table</Typography>
					</Box>
				
					<TableContainer component={Paper} style={{width: '99%', height: "55vh", border: '1px solid #D9D9D9', marginTop: "0.2rem", "&::-webkit-scrollbar":{
											display: 'none'
										},
										scrollbarWidth: "none"}}>
						<Table stickyHeader>
							<TableHead style={{backgroundColor: mediumGrey}}>
								<TableRow style={{backgroundColor: "blue", padding: '0rem 0rem 0rem 0rem'}}>
									<TableCell style={{...headerCellStyle, backgroundColor: mediumGrey, fontWeight: '550'}}>
										Title
									</TableCell>
									<TableCell style={{...headerCellStyle, backgroundColor: mediumGrey, fontWeight: '550'}}>
										Task cateogary
									</TableCell>
									<TableCell style={{...headerCellStyle, backgroundColor: mediumGrey, fontWeight: '550'}}>
										Assignee
									</TableCell>
									<TableCell style={{...headerCellStyle, backgroundColor: mediumGrey, fontWeight: '550'}}>
										Date
									</TableCell>
									<TableCell style={{...headerCellStyle, backgroundColor: mediumGrey, fontWeight: '550'}}>
										Progress
									</TableCell>
									<TableCell style={{...headerCellStyle, backgroundColor: mediumGrey, fontWeight: '550'}}>
										Created By
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody style={{ textAlign: 'center', overflowY: 'auto'}}>
								{props?.data?.records?.map((row, index) => {
									let percentage = (row?.done / (row?.done + row?.pending)) * 100
									let color = percentage <= 50 ? maroon : percentage <= 75 ? orange : percentage <= 90 ? amber : green
									return(
										<TableRow key={index}>
											<TableCell style={{...headerCellStyle}}>
												{row?.taskTitle}

											</TableCell>
											<TableCell style={{...headerCellStyle}}>
												{(taskTypeList.find(ele => ele.value === row?.taskCategory))?.name}
											</TableCell>
											<TableCell style={{...headerCellStyle}}>
												{row?.assignedTo[0]}
											</TableCell>
											<TableCell style={{...headerCellStyle}}>
												{row?.date.split('T')[0]} <br></br>
												{(row?.date.split('T')[1]).split('.')[0]}
											</TableCell>
											<TableCell style={{...headerCellStyle}}>
												<Tooltip title={`${row?.done} / ${(row?.done + row?.pending)} - ${percentage.toFixed(2)} %`}>
													<Box style={{padding: '0rem 0.25rem 0rem 0rem'}}>
														<LinearProgress
															variant='determinate'
															value={percentage}
															sx={{
																height: 10,
																borderRadius: 5,
																backgroundColor: mediumGrey,
																"& .MuiLinearProgress-bar": {
																	backgroundColor: color,
																}
															}}
														></LinearProgress>
													</Box>
												</Tooltip>
											</TableCell>
											<TableCell style={{...headerCellStyle}}>
												{row?.createdByName} <br></br>
												{row?.createdByCN}
											</TableCell>
										</TableRow>
									)
								})

								}
							</TableBody>
						</Table>
					</TableContainer>
				</Box>
				<Box style={{display: 'flex', justifyContent: 'center',padding: "0.4rem 0rem 0.1rem 0rem"}}>
					<Box style={{width: "30%", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: "0rem 0.5rem 0rem 0.9rem"}}>
							<Typography style={{color: maroon, fontSize: '0.9rem'}}>
								{((props?.pageValue - 1) * props?.offsetValue) +1} - {(props?.pageValue * props?.offsetValue) < props?.data?.totalRecords ? (props?.pageValue * props?.offsetValue) : props?.data?.totalRecords } of {props?.data?.totalRecords}
							</Typography>
					</Box>
					<Box style={{width: '40%',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
						<IconButton size='small'
							onClick={() => {
								if(props.pageValue > 1){
									props.updatePage(props.pageValue - 1)
								}
							}}
							disabled={props.pageValue === 1}
						><KeyboardArrowLeft size='small' sx= {{color: props.pageValue === 1 ? mediumGrey: headingBlue}}
						/></IconButton>
						<Button variant='contained' style={{minWidth: '0rem', width: '1.5rem', height: '1.5rem',borderRadius: '50%', backgroundColor: headingBlue, color: 'white', padding: '0rem', alignItems: 'center'}}>{props.pageValue}</Button>
						<IconButton size='small'
							onClick={() => {
								if(props.pageValue < props.data.totalPages){
									props.updatePage(props.pageValue + 1)
								}
							}}
							disabled={props.pageValue === props.data.totalPages}
						><KeyboardArrowRight size='small' sx= {{color: (props.pageValue === props.data.totalPages || props.data.totalPages === 0) ? mediumGrey: headingBlue}}
						/></IconButton>

					</Box>
					<Box style={{width: '30%',display: 'flex', justifyContent: 'flex-end', padding: "0rem 0.6rem 0rem 0rem"}}>
						<CustomDropDown key='table' value={props.offsetValue} width="5rem" setFunc={props.updateOffset} list={tableOffsets2} regular={true}></CustomDropDown>
					</Box>

				</Box>

			</Paper>

    </Box>
    </>
  )
}

export default TaskTable
